export default __webpack_public_path__ + "static/media/photo_5282747746622312924_y.5d040a60.jpg";